import TokenService from "./tokenService";


export const isAuthenticated = () => {
    return TokenService.getAccessToken() && TokenService.getRefreshToken();
};

